import { type FC } from "react";
import { type SweepstakesAnswerKey } from "@/utils/constants";
import QuizOption from "../QuizOption";
import { Body, Subhead } from "../SweepstakesText";
import { type PopupCopy } from "../popupContent";

const QuizStep: FC<{
  copy: PopupCopy["quiz"];
  onAnswer: (answer: SweepstakesAnswerKey | null) => void;
}> = ({ copy, onAnswer }) => {
  return (
    <div className="flex w-full flex-col items-center gap-5 text-center md:gap-6 xl:gap-8 2xl:gap-10">
      <div className="flex w-full flex-col items-center gap-2">
        <Subhead>{copy.subhead}</Subhead>
        <Body>{copy.body}</Body>
      </div>
      <div className="flex w-full flex-col items-center gap-[12px]">
        {copy.options.map((option) => (
          <QuizOption
            key={option.key}
            label={option.label}
            onClick={() => onAnswer(option.key)}
          />
        ))}
      </div>
      <button
        type="button"
        onClick={() => onAnswer(null)}
        className="font-ppMori text-[12px] leading-[16px] text-[#1f2022] underline md:text-[13px] md:leading-[18px] 2xl:text-[14px] 2xl:leading-[20px]"
      >
        {copy.skip}
      </button>
    </div>
  );
};

export default QuizStep;
